import React, { Fragment } from "react";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
// styled components
import { TabLink } from "./styles";

interface Tab {
  page: number;
  name: string;
  entity: string;
  component: any
}

interface Props {
  tabs: Tab[];
  selectedPage: number;
  setSelectedPage: (page: number) => void;
  reintentosQuantity:number;
  pendienteDescargaQuantity:number;
  setReintentosQuantity:(param: number) => void;
  setPendienteDescargaQuantity:(param: number) => void;
}

export default (props: Props) => {
  return (
    <Fragment>
      <ul className="nav nav-tabs" style={{paddingTop: "20px"}}>
        {props.tabs.map((tab: Tab, key: number) => {
          return (
            <li key={key}>
              <TabLink
                activeTab={props.selectedPage === tab.page}
                onClick={() => props.setSelectedPage(tab.page)}
                data-cy={`NavTab-${tab.name.replace(/\s/g, '_')}`}
              >    
                  {    
                    ((tab.entity === "rejected_orders" && props.reintentosQuantity !== 0) ||
                    (tab.entity === "budgets" && props.pendienteDescargaQuantity !== 0)) &&
                    <BadgeContainer  >
                      <div style={{display:"flex"}}>
                        <div className="text-center">{tab.name}</div>
                        &nbsp;
                        <Badge position="inside" fill="solid" size="large" style={{backgroundColor: (tab.entity === "rejected_orders"?'red':'#007bff'), borderColor: (tab.entity ===  "rejected_orders"?'red':'#007bff')}}>
                          {
                            (tab.entity === "rejected_orders")  && props.reintentosQuantity
                          }
                          {
                            (tab.entity === "budgets") && props.pendienteDescargaQuantity
                          }
                        </Badge>
                      </div>
                    </BadgeContainer>
                  
                  }
                  {
                    ((tab.entity === "rejected_orders" && props.reintentosQuantity === 0) ||
                     (tab.entity === "budgets" && props.pendienteDescargaQuantity === 0) ||
                     tab.entity === "orders" || tab.entity === "seller_stats") &&
                    <div className="text-center">{tab.name}</div>
                  } 
              </TabLink>
            </li>
          )
        })}
      </ul>
    </Fragment>
  );
};
